export const LOGIN = "/login";
export const HOME = "/";
